module.exports = __webpack_public_path__ + "static/media/add-white.30912b51.svg";